/* tslint:disable */
import {
  OrderItem,
  Payment,
  Card
} from '../index';

declare var Object: any;
export interface OrderInterface {
  "id"?: string;
  "partnerId": string;
  "reference": string;
  "status": number;
  "paymentMethod": number;
  "dateCreated": Date;
  "lastUpdated": Date;
  "subTotal": number;
  "totalDiscount"?: number;
  "totalVolumeDiscount"?: number;
  "totalAmount": number;
  "totalPayment": number;
  "totalTax": number;
  "totalVat"?: number;
  "totalNetOfVat"?: number;
  "dateSettled"?: Date;
  "ORNumber"?: string;
  "ORDate"?: Date;
  "ticketNumber"?: string;
  "failedGenerateOR"?: boolean;
  "reprocessingCounter"?: number;
  orderItems?: OrderItem[];
  payments?: Payment[];
  cards?: Card[];
}

export class Order implements OrderInterface {
  "id": string;
  "partnerId": string;
  "reference": string;
  "status": number;
  "paymentMethod": number;
  "dateCreated": Date;
  "lastUpdated": Date;
  "subTotal": number;
  "totalDiscount": number;
  "totalVolumeDiscount": number;
  "totalAmount": number;
  "totalPayment": number;
  "totalTax": number;
  "totalVat": number;
  "totalNetOfVat": number;
  "dateSettled": Date;
  "ORNumber": string;
  "ORDate": Date;
  "ticketNumber": string;
  "failedGenerateOR": boolean;
  "reprocessingCounter": number;
  orderItems: OrderItem[];
  payments: Payment[];
  cards: Card[];
  constructor(data?: OrderInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Order`.
   */
  public static getModelName() {
    return "Order";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Order for dynamic purposes.
  **/
  public static factory(data: OrderInterface): Order{
    return new Order(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Order',
      plural: 'Orders',
      path: 'Orders',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'string'
        },
        "partnerId": {
          name: 'partnerId',
          type: 'string'
        },
        "reference": {
          name: 'reference',
          type: 'string'
        },
        "status": {
          name: 'status',
          type: 'number',
          default: 0
        },
        "paymentMethod": {
          name: 'paymentMethod',
          type: 'number',
          default: 0
        },
        "dateCreated": {
          name: 'dateCreated',
          type: 'Date'
        },
        "lastUpdated": {
          name: 'lastUpdated',
          type: 'Date'
        },
        "subTotal": {
          name: 'subTotal',
          type: 'number',
          default: 0
        },
        "totalDiscount": {
          name: 'totalDiscount',
          type: 'number',
          default: 0
        },
        "totalVolumeDiscount": {
          name: 'totalVolumeDiscount',
          type: 'number',
          default: 0
        },
        "totalAmount": {
          name: 'totalAmount',
          type: 'number',
          default: 0
        },
        "totalPayment": {
          name: 'totalPayment',
          type: 'number',
          default: 0
        },
        "totalTax": {
          name: 'totalTax',
          type: 'number',
          default: 0
        },
        "totalVat": {
          name: 'totalVat',
          type: 'number',
          default: 0
        },
        "totalNetOfVat": {
          name: 'totalNetOfVat',
          type: 'number',
          default: 0
        },
        "dateSettled": {
          name: 'dateSettled',
          type: 'Date'
        },
        "ORNumber": {
          name: 'ORNumber',
          type: 'string'
        },
        "ORDate": {
          name: 'ORDate',
          type: 'Date'
        },
        "ticketNumber": {
          name: 'ticketNumber',
          type: 'string'
        },
        "failedGenerateOR": {
          name: 'failedGenerateOR',
          type: 'boolean',
          default: false
        },
        "reprocessingCounter": {
          name: 'reprocessingCounter',
          type: 'number',
          default: 0
        },
      },
      relations: {
        orderItems: {
          name: 'orderItems',
          type: 'OrderItem[]',
          model: 'OrderItem',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'orderId'
        },
        payments: {
          name: 'payments',
          type: 'Payment[]',
          model: 'Payment',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'orderId'
        },
        cards: {
          name: 'cards',
          type: 'Card[]',
          model: 'Card',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'orderId'
        },
      }
    }
  }
}
